import { PeriodPickerProps } from '@touche-lts/panel-ui/dist/components/shared/period-picker'

export enum OrdersTableSortProps {
    NUMBER = 'number',
    USERID = 'userId',
    STORE = 'store',
    DATE = 'date',
    ORDERSTATUS = 'orderStatus',
    EXTERNALID = 'externalId',
    TOTAL = 'total',
    PRODUCTSTOTAL = 'productsTotal',
    SHIPPINGTOTAL = 'shippingTotal',
    CREDITCARDID = 'creditCardId',
    TRANSACTIONNUMBER = 'transactionNumber',
    PLATFORM = 'platform',
    PRODUCTS = 'products',
    CUSTOMER = 'firstName',
    PLACEORDERTOSHOPIFY = 'placeOrederToShopify'
}

export enum OrdersTableStatus {
    PROCESSING = 'processing',
    UNDEFINED = 'undefined',
    DECLINED = 'declined',
    AUTHORIZE = 'authorize',
    CANCELLED = 'cancelled',
    CHARGED = 'charged',
    REFUNDED = 'refunded',
    CHARGEBACK = 'chargeback',
    REFUNDCHARGEBACK = 'refund_chargeback',
    CHARGEBACKCHBREFUND = 'chargeback_chbrefund',
    REFUNDCHARGEBACKCHBREFUND  = 'refund_chargeback_chbrefund',
    // For Shopify integration
    ERROR = 'error',
    FULFILLED = "fulfilled",
    UNFULFILLED = "unfulfilled",
    PARTIALLY_FULFILLED = "partially_fulfilled",
    SCHEDULED = "scheduled",
    ON_HOLD = "on_hold",
    CONFIRMED = "confirmed",
    ON_ITS_WAY = "on_its_way",
    OUT_FOR_DELIVERY = "out_for_delivery",
    DELIVERED = "delivered",
    ATTEMPTED_DELIVERY = "attempted_delivery"
}

export interface OrdersTableSearchProps {
    firstName: string;
    customerId: number;
    maxAmount: number;
    maxDate: string;
    minAmount: number;
    minDate: string;
    orderDate?: PeriodPickerProps['period'];
    number: number;
    status: string;
    store: string;
}

export const orderTableCellWidth = {
    NUMBER : 260,
    DATE : 260,
    ORDERSTATUS : 260,
    TOTAL : 251,
    CUSTOMER : 260,
    PLACEORDERTOSHOPIFY : 200,
    STORE : 260
}